import { getDescriptionDetailTextType } from './types';

export const getDescriptionDetailText: getDescriptionDetailTextType = ({ points }) => {
  return points.toString();
};
